export enum VarType {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  BOOLEAN = 'boolean',
}

export enum ModelType {
  DEBTOR = 'debtor',
}

export enum DisplayType {
  MONEY = 'money',
  MONEY_IN_CENTS = 'money_in_cents',
  PERCENTAGE = 'percentage',
}
